const translations = {
	page_title: "Souscriptions",
	dropdown_button_text: "Lancer une nouvelle souscription",
	back_to_subscriptions: "Retour aux souscriptions",
	table: {
		find_subscrition: "Chercher une souscription",
		civility: "Civilité",
		lastname: "Nom",
		name: "Prénom",
		product_name: "Nom du produit",
		subscription_product_type: "Type de souscription",
		amount_subscribed: "Montant souscrit",
		payment_method: "Mode de réglement",
	},
	unsaved_modifications: "Les modifications apportées n'ont pas été enregistrées.",
	continue_unsave: "Continuer sans enregistrer",
	analyse_processing: "Analyse en cours",
	sub_pages: {
		in_progress: {
			page_title: "Brouillons",
			civility: "Civilité",
			lastname: "Nom",
			name: "Prénom",
			subscriber: "Souscripteur",
			number_of_products: "Nombre de produits",
			amount_subscribed: "Montant souscrit",
			type: "Type",
			modal: {
				title: "Êtes-vous sûr ?",
				irreversible: "Cette action est irréversible.",
			},
		},
		waiting_signature: {
			page_title: "En attente de signature",
			date: "Date d'envoi pour signature au client",
		},
		waiting_contrepartie: {
			page_title: "En attente de contrepartie",
			date: "Date d'envoi pour contrepartie",
		},
		waiting_transfer_sg: {
			page_title: "À transmettre SDG",
			button: "Transmettre",
		},
		waiting_validation: {
			page_title: "En attente de validation SDG",
		},
		validated: {
			page_title: "Validées",
			date: "Date de validation",
		},
	},
	existing_clients: {
		page_title: "Clients existants",
		title: "Sélectionner le client",
		launch_co_subscription: "Lancer une co-souscription",
		launch_subscription: "Lancer une souscription seul",
		modal_verify_client: {
			title: "Vérification",
			subtitle: "Veuillez vérifier les informations de votre client et de les compléter/modifier si nécessaire.",
		},
		modal_no_co_suscriber: {
			title: "Conjoint introuvable",
			text: "Le client sélectionné n'a pas encore de conjoint",
			cta: "Créer la fiche du conjoint",
		},
		modal_not_valid_client: {
			title: "Attention",
			spouse_title: "Attention, conjoint non valide",
			text: "Veuillez compléter l'ensemble des informations afin de pouvoir souscrire pour ce client.",
		},
	},
	existing_corporation: {
		page_title: "Selection d'une personne morale",
		title: "Sélectionner le client",
		subtitle: "Sélectionnez dans la liste ci-dessous la société concernée par cette souscription.",
		launch_co_subscription: "Lancer une co-souscription",
		launch_subscription: "Lancer une souscription",
		modal_no_co_suscriber: {
			title: "Conjoint introuvable",
			text: "Le client sélectionné n'a pas encore de conjoint",
			cta: "Créer la fiche du conjoint",
		},
	},
	validation_documents: {
		page_title: "Vérification des documents générés",
		modal: {
			title: "Souscription finalisée",
			now: "Vous pouvez dès-à-présent vérifier et valider les documents de souscription avant leur envoi en signature électronique.",
			next_step: "Prochaines étapes :",
			validate_convention: "1- Valider la convention RTO",
			validate_documents: "2- Valider les documents de souscription de chaque produit",
			validate_documents_without_rto: "Valider les documents de souscription de chaque produit",
			report: "Vous pouvez signaler une erreur lors de votre vérification.",
			question: "En cas de question, vous pouvez nous contacter à :",
			address: "backoffice@wenimmo.com",
			close: "J'ai compris",
		},
	},
	upload_documents: {
		page_title: "Dépôt des documents",
		finalize: "Finaliser la souscription",
		description:
			"Pour terminer votre parcours, merci de bien vouloir télécharger l'ensemble des justificatifs nécessaires à la validation de votre dossier auprès des sociétés de gestion.",
		checkbox_text:
			"Dans le cadre du document d'entrée en relation signé par mon client, celui-ci accepte de transmettre ses données personnelles pour le traitement de son dossier.",
		documents_needed: "Faites attention a bien fournir tous les documents demandés.",
		modal: {
			title: "Souscription finalisée",
			description:
				"Le dossier a été transmis au back office de Wenimmo.\n\nAprès étude du dossier par nos services, vous recevrez un lien d'approbation de yousign vous invitant à vérifier les documents et les approuver.\n\nDeux possibilités :\n\n- Vous approuvez → votre client recevra automatiquement un lien de signature.\n- Vous signalez une erreur → le dossier est corrigé par nos équipes, puis un nouveau lien vous sera envoyé.\n\nVous avez également la possibilité de nous contacter :",
			demembrement_note: "À noter : Si vous disposez de la contrepartie (nue-propriété ou usufruit), pensez à créer une seconde souscription pour compléter le démembrement.",
			address: "backoffice@wenimmo.com",
		},
		uploaders: {
			cartId: "Pièce d'identité (en cours de validité)*",
			rib: "RIB de perception des dividendes*",
			rib_prelevement: "RIB de prélèvement (si différent du RIB dividendes)",
			domicileProof: "Justificatif de Domicile (moins de 3 mois)*",
			fundsOrigin: "Justificatif(s) d'Origine des Fonds*",
			others: "Autres documents (tous relevés de comptes permettant la traçabilité des fonds, attestation, ...)",
			spouseCartId: "Pièce d'identité du conjoint*",
			rib_corporation: "RIB de perception des dividendes*",
			rib_prelevement_corporation: "RIB de prélèvement (si différent du RIB dividendes)",
			kbis: "Kbis infogreffe (de moins de 3 mois) *",
			certified_status: "Statuts certifiés conformes (datés et signés de moins de 3 mois) * ",
			card_id_legal_representative: "Carte d'identité du représentant légal*",
			justificatif_domicile_legal_representative: "Justificatif de domicile du représentant légal*",
			beneficiaries_list: "Liste des bénéficiaires effectifs*",
			justificatif_origine_fonds_corporation: "Justificatif d'origine des fonds (correspondant à l'origine déclarée)*",
			beneficiaries_id: "Pièce d'identité des bénéficiaires effectifs*",
			beneficiaries_proof_address: "Justificatif de domicile des bénéficiaires effectifs*",
			liasse_fiscale: "Liasse fiscale ou formulaire 2072 (le cas échéant)",
			dernier_releve_compte: "Le dernier relevé de compte avec solde suffisant (recommandé)",
			contrat_mariage_pacs: "Contrat de mariage ou PACS (le cas échéant)",
		},
	},
	create_client: {
		page_title: "Création nouveau client",
		title: "Création nouveau client",
		back: "Retour aux souscriptions",
	},
	create_corporation: {
		page_title: "Personne morale",
		title: "Création personne morale",
		back: "Retour aux souscriptions",
		beneficiaries: {
			is_legal_representative_beneficiary: "Le représentant légal est-il un bénéficiaire effectif ?",
			beneficiary_is: "Le bénéficiaire effectif est un",
			add_beneficiary: "Ajouter un bénéficiaire",
			effectiv_beneficiary: "Bénéficiaire effectif",
			beneficiary: "Bénéficiaire",
			new_client: "Nouveau client",
			existing_client: "Client existant",
			edit_beneficiaries: "Edition du bénéficiaire",
		},
		legal_representative: {
			legal_representative_is: "Le représentant légal est un",
			message_signataire: "Fournir le pouvoir du signataire le cas échéant",
			legal_representative: "Représentant légal",
			edit_legal_representative: "Edition du représentant légal",
		},
	},
	summary: {
		page_title: "Récapitulatif",
		page_title_corporation: "Récapitulatif",
		title: "Récapitulatif",
	},
	select_products: {
		page_title: "Sélection des produits",
		title: "Sélection des produits",
		subtitle: "Sélectionnez les produits auxquels votre client souhaite souscrire et ajoutez-les au panier.",
		next_page: "Passer à l'étape suivante",
		total_amount: "Montant total de la souscription",
		table: {
			columns: {
				subscription_product_type: "Type de souscription",
				scpi: "Produits disponibles",
				paiement_method: "Mode de réglement",
				quantity: "Nombre de parts",
				amount: "Nombre de parts",
				calculated_price: "Montant de la souscription",
				start_price: "Prix de part",
			},
			placeholders: {
				select_scpi: "Sélectionner un produit",
				select_paiement_method: "Sélectionner un mode de réglement",
			},
		},
		demembrement_config: {
			title: "Configuration démembrement",
			type: "Type",
			duration: "Durée de démembrement (années)",
			repartition_key: "Clé de répartition",
			access_keys: "Accéder aux clés de répartition",
			type_temporaire: "Temporaire",
			type_viager: "Viager",
			viager_age: "Âge de l'usufruitier",
			contrepartie_label: "Contrepartie",
			contrepartie_avec: "Avec contrepartie",
			contrepartie_sans: "Sans contrepartie",
			contrepartie_nom: "Nom de la contrepartie",
		},
		usufruit_warning: {
			message:
				"Si vous n'avez pas la contre-partie en nue-propriété. La souscription risque d'être refusée par la société de gestion. En cas de doutes, veuillez contacter wenimmo : ",
			email: "backoffice@wenimmo.com",
		},
		with_contrepartie_warning:
			"Si vous disposez de la contrepartie (nue-propriété ou usufruit), veuillez finaliser cette souscription, puis créer une seconde souscription pour la contrepartie.",
		modal85years: {
			text: "Vous ne pouvez pas sélectionner Kyaneos. Cette SCPI n'accepte pas les souscripteurs âgés de plus de 85 ans.",
			button: "J'ai compris",
		},
		modalCategoryChange: {
			text: "Vous avez déjà sélectionné des produits de type {{currentType}}. En changeant de catégorie vers {{newType}}, tous les produits sélectionnés seront supprimés. Voulez-vous continuer ?",
			button: "Continuer",
		},
		modal: {
			text: `Il est nécessaire d'acquérir un minimum de {{minimumShare}} parts lors de la première souscription à ce produit.Avant de procéder à la souscription, veuillez vérifier que votre client détient déjà des parts de ce produit.`,
			button: "J'ai compris",
		},
	},
	payment_methods: {
		page_title_corporation: "Règlement",
		page_title: "Réglement",
		title: "Règlement",
		description: "Spécifiez les modalités de règlement des souscriptions de votre client.",
		prelevement_info:
			"Si co-souscription : Règlement d'un compte joint recommandé. Si souscription seule : Règlement d'un compte au nom seul du souscripteur recommandé. Dans le cas contraire, les sociétés de gestion sont susceptibles de demander des éléments complémentaires.",
	},
	patrimoine_revenus: {
		page_title: "Patrimoine et revenus",
		page_title_corporation: "Patrimoine et revenus",
		title: "Patrimoine et revenus",
		questions: {
			dontEnfantsACharge: "Dont enfants à charge",
			situationFinanciereCorporation: {
				capitauxPropre: "Capitaux propres",
				totalBilan: "Total du bilan",
				resultatNet: "Résultat net",
				capitalSocial: "Capital social",
				chiffreDAffaire: "Chiffre d'affaire",
			},
			compositionPatrimoine: {
				immobilierUsage: "Immobilier d'usage",
				immobilierLocatif: "Immobilier locatif",
				actifsFinanciers: "Autres actifs financiers",
				assuranceVie: "Assurance vie",
				liquidites: "Liquidités",
				actifsProfessionnels: "Actifs professionnels",
				epargneRetraite: "Epargne retraite",
				scpi: "SCPI",
				actions: "Actions",
				obligations: "Obligations",
				autre: "Autre",
			},
			compositionPatrimoineCorporation: {
				patrimoineImmobilier: "Patrimoine Immobilier",
				patrimoineFinancier: "Patrimoine financier",
				titresScpiOpci: "dont titres SCPI/OPCI",
				liquiditesTresorerie: "Liquidités/Trésorerie",
			},
			originePatrimoine: {
				salaire: "Salaire",
				valorisation: "Création/valorisation d'une entreprise ou d'un fonds de commerce",
				heritage: "Héritage",
			},
			originePatrimoineCorporation: {
				salaire: "Salaire",
				creation_valorisation_entreprise: "Création/valorisation d'une entreprise ou d'un fonds de commerce",
				heritage: "Héritage",
			},
			compositionRevenus: {
				immobiliers: "Revenus immobiliers",
				salaires: "Salaires",
				retraites: "Retraites",
				financiers: "Revenus financiers",
				mobiliers: "Revenus mobiliers",
				autres: "Autre",
			},
			compositionRevenusCorporation: {
				revenusImmobiliers: "Revenus immobiliers",
				activite: "Activité",
				retraites: "Retraites",
				revenusFinanciers: "Revenus financiers",
				autre: "Autre",
			},
			revenuCharge: {
				nature: "Nature",
				montant: "Montant",
			},
		},
	},
	files: {
		page_title: "Documents",
		page_title_corporation: "Documents",
		title: "Documents",
	},
	connaissance_experience: {
		page_title: "Connaissance & expérience",
		page_title_corporation: "Connaissance & expérience représentant légal",
		title: "Connaissance & expérience",
		supportPlacement: {
			queVousConnaissez: "Que vous connaissez",
			dontVousDisposez: "Dont vous disposez",
			nombreSouscriptions: "Nombre de souscriptions au cours des 12 derniers mois",
			frequenceTransaction: "Fréquence moyenne des transactions",
			moyenneTransaction: "Moyenne de transaction en €",
			scpiOpciNombreSouscriptions: "Nombre de souscriptions de parts de SCPI",
		},
	},
	autre_cgp: {
		page_title: "Appréciation sur l'opération",
		page_title_corporation: "Appréciation sur l'opération",
		title: "Appréciation sur l'opération",
	},
	test_adequation: {
		page_title: "Test d'adéquation",
		page_title_corporation: "Test d'adéquation",
		title: "Test d'adéquation",
	},
	finance_durable: {
		page_title: "Finance durable",
		page_title_corporation: "Finance durable",
		title: "Finance durable",
	},
	new_subscription_modal: {
		title: "Lancer une souscription",
		new_client: "Nouveau client",
		existing_client: "Client existant",
	},
	reset_documents_modal: {
		title: "Confirmer vos modifications",
		message: "Modifier ces informations entraînera la régénération des documents de souscription.",
		warning_text: "📍 Important : Si vous avez déjà vérifié des documents (dernière étape), vous devrez les vérifier à nouveau après cette modification.",
		confirm_button: "Confirmer et passer à la vérification",
	},
	report_error_modal: {
		title: "Signaler une erreur",
		message:
			"Vous signalez une erreur, nos équipes la traiteront dans les plus brefs délais.\n\nVous recevrez ensuite un lien d’approbation de yousign, vous invitant à vérifier les documents et les approuver.\n\nAinsi :\n- Soit vous approuvez en cliquant sur « confirmer » et votre client reçoit automatiquement un lien de signature\n- Soit vous refusez et signalez de nouveau une erreur. Celle-ci sera analysée et corrigée par nos services et vous recevrez à nouveau un lien d’approbation”",
		placeholder: "Veuillez fournir un maximum de détails concernant le type de document concerné ainsi que l’erreur que vous avez remarqué.",
		confirm_button: "Envoyer",
		cancel_button: "Annuler",
		success_message: "Merci, votre message a bien été envoyé.",
		error_message: "Une erreur est survenue lors de l'envoi du message.",
	},
};

export default translations;
